export default "__VITE_ASSET__DWSy3SvQ__"